// extracted by mini-css-extract-plugin
export default {"orderView":"Layout_orderView__6KXOR","header":"Layout_header__kGQ+m","back":"Layout_back__h2qPV","title":"Layout_title__AvDGW","subTitle":"Layout_subTitle__Qvfgr"};